import axios from 'axios'
import store from '../store'
import { decryptData } from '@/api/encrypt'
import { Message, MessageBox } from 'element-ui'

var num = 0
const service = axios.create({
  // baseURL: '/api'
  baseURL: '/sa-admin-api'
})

service.interceptors.request.use(
  config => {
    // alert(getToken())
    // console.log(getToken())

    if (config.url.indexOf('?') > -1) {
      config.url = config.url
    } else {
      config.url = config.url
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    // num++
    // if (num == 1 || num > 1) {
    //     alert(geVtToken())
    // }
    // return false
    const res = response.data
    if (res.code !== 0) {
      if (res.code === 500) {
        Message.closeAll()
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 2 * 1000
        })
        return res
      } else if (
        res.code == 200105 ||
        res.code == 200101 ||
        res.code == 200100
      ) {
        num++
        if (num == 1 || num > 1) {
          MessageBox.confirm(
            '系统检测到您长时间未登录，您可以取消停留在该页上，或重新登录',
            'Confirm logout',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            clearCookie()
            window.location.href = '/#/login'
            location.reload()
          })
          return false
        } else {
          clearCookie()
          window.location.href = '/#/login'
          location.reload()
          return false
        }
      } else if (res.code == 300021) {
        Message.closeAll()
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 2 * 1000
        })
        return res
      } else if (res.code == 110) {
        var www = decryptData(res.data)
        var bbb = JSON.parse(www)
        console.log(bbb)

        return bbb
      } else {
        if (res.code == undefined) {
          return res
        }
        Message.closeAll()
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 2 * 1000
        })
      }
    } else {
      return res
    }
  },
  error => {
    Message.closeAll()
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = error.response.data.msg
          break
        case 500:
          error.message = '系统繁忙，请稍后重试！'
          break
        default:
          error.message = '系统繁忙，请稍后重试！'
      }
    }

    Message({
      message: error.message,
      type: 'error',
      duration: 2 * 1000
    })
    return Promise.reject(error)
  }
)

function clearCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
  if (keys) {
    for (var i = keys.length; i--; ) {
      document.cookie =
        keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() //清除当前域名下的,例如：m.kevis.com
      document.cookie =
        keys[i] +
        '=0;path=/;domain=' +
        document.domain +
        ';expires=' +
        new Date(0).toUTCString() //清除当前域名下的，例如 .m.kevis.com
      document.cookie =
        keys[i] +
        '=0;path=/;domain=kevis.com;expires=' +
        new Date(0).toUTCString() //清除一级域名下的或指定的，例如 .kevis.com
    }
  }
}
export default service
